export enum ReferenceValueSources {
  Section = 'section',
  CmCourse = 'curriculumCourse',
}
